import { createElement, forwardRef } from 'react';
import cn from 'classnames';
import { Root, Trigger as Trigger$1, Content as Content$1 } from '@radix-ui/react-hover-card';

const Trigger = /*#__PURE__*/forwardRef(function HoverCardTrigger(props, ref) {
  return createElement(Trigger$1, Object.assign({}, props, {
    asChild: true,
    ref: ref
  }));
});
const Content = /*#__PURE__*/forwardRef(function HoverCardContent(externalProps, ref) {
  const {
    placement,
    ...props
  } = externalProps;
  const className = cn('bg-white rounded p-3 yt-shadow', props.className);
  return createElement(Content$1, Object.assign({}, props, {
    className: className,
    ref: ref,
    side: placement
  }));
});
const HoverCard = props => {
  return createElement(Root, Object.assign({}, props, {
    openDelay: 300
  }));
};
HoverCard.Trigger = Trigger;
HoverCard.Content = Content;

export { HoverCard };
//# sourceMappingURL=HoverCard.js.map
